(function () {
  function mount() {
    const copies = document.querySelectorAll('[data-cebe-roast-copy]');
    if (!copies.length) return;
    const band = document.querySelector('[data-cebe-roast]:not([data-preview])');
    const sync = function () {
      const active = Boolean(band && band.isConnected && !band.hidden);
      copies.forEach(function (copy) { copy.hidden = !active; });
    };
    sync();
    if (band) {
      const observer = new MutationObserver(sync);
      observer.observe(band, { attributes: true, attributeFilter: ['hidden'] });
      if (band.parentElement) observer.observe(band.parentElement, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
